if (!window.__srCartAgreementGateLoaded) {
  window.__srCartAgreementGateLoaded = true;

  function srUpdateCheckoutButtons() {
    document.querySelectorAll('.cart-agreement-group').forEach(function (group) {
      var boxes = group.querySelectorAll('.cart-agreement-checkbox');
      var allChecked = Array.prototype.every.call(boxes, function (cb) {
        return cb.checked;
      });
      var scope = group.parentElement;
      if (!scope) return;
      var btn = scope.querySelector('.cart__checkout-button');
      if (btn) {
        btn.disabled = !allChecked;
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('cart-agreement-checkbox')) {
      srUpdateCheckoutButtons();
    }
  });

  document.addEventListener('DOMContentLoaded', srUpdateCheckoutButtons);
  srUpdateCheckoutButtons();

  var srCartAgreementObserver = new MutationObserver(function () {
    srUpdateCheckoutButtons();
  });
  srCartAgreementObserver.observe(document.documentElement, { childList: true, subtree: true });
}
